import { createSelector } from 'reselect';

const getVehicles = (state) => state.vehicles.data;
const getRoutes = (state, routes) => routes;
const getBranchNumber = (state, routes, branchNumber) => branchNumber;


const isToday = (date) => {
    const d = new Date(date);
    const now = new Date();
    return (
        d.getFullYear() === now.getFullYear() &&
        d.getMonth() === now.getMonth() &&
        d.getDate() === now.getDate()
    );
}


export const getVehiclesWithNoRoute = createSelector(
    [ getVehicles, getRoutes, getBranchNumber ],
    (vehicles, routes, branchNumber) => {

        const routeVehicles = Object.values(routes).reduce((acc, route) => {
            if (route.branch_nummer === branchNumber && route.licenseplate) {
                acc.push(route.licenseplate);
            }
            return acc;
        }, []);

        const branchVehicles = Object.values(vehicles).filter((vehicle) => {
            if (vehicle.positionUpdated && !isToday(vehicle.positionUpdated)) {
                return false;
            }
            return (vehicle.branch_nummer === branchNumber && !routeVehicles.includes(vehicle.licenseplate));
        });

        return branchVehicles;

    }
);